import { dehydrate, QueryClient } from '@tanstack/react-query'
import { EAgentAuthQueryKey } from './agent-auth.types'
import agentAuthService from './agent-auth.service'
import { Cookie } from '@repo/tools'

export const agentAuthDetailsOptions = () => {
  return {
    queryKey: [EAgentAuthQueryKey.AGENT_AUTH_DETAILS],
    queryFn: () => agentAuthService.agentDetails(),
    enabled: !!Cookie.get('access_token'),
  }
}

export const prefetchAgentAuthDetails = async () => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(agentAuthDetailsOptions())
  return dehydrate(queryClient)
}
